module.exports = __webpack_public_path__ + "static/media/menu21.397bee35.jpg";